import axios from "axios";
import { HOST } from "config/config";
import tableDataQueryStringBuilder from "utils/tableData";

export function getTaxTypeApplications(tableDataParam, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().taxTypeApplicationsReducer.updating || forceRefresh) {
      if (tableDataParam === undefined) {
        return dispatch({
          type: "GET_TAX_TYPE_APPLICATIONS_PENDING",
          payload: axios
            .get(`${HOST}/api/tax-type-applications`)
            .then(response => response.data)
            .then(json =>
              dispatch({
                type: "GET_TAX_TYPE_APPLICATIONS_FULFILLED",
                payload: {
                  items: json
                }
              })
            )
            .catch(error =>
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.message
                }
              })
            )
        });
      }

      return dispatch({
        type: "GET_TAX_TYPE_APPLICATIONS_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-applications`, {
            paramsSerializer: params => tableDataQueryStringBuilder(params),
            params: tableDataParam
          })
          .then(response => response.data)
          .then(json => {
            if (tableDataParam) {
              dispatch({
                type: "UPDATE_TAX_TYPE_APPLICATIONS_TABLEDATAPARAM",
                payload: tableDataParam
              });
            }

            dispatch({
              type: "GET_TAX_TYPE_APPLICATIONS_FULFILLED",
              payload: json
            });
          })
          .catch(error =>
            dispatch({
              type: "GET_TAX_TYPE_APPLICATIONS_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function getTaxTypeApplicationsForSelect() {
  return (dispatch, getState) => {
    if (!getState().taxTypeApplicationsReducer.updating) {
      return dispatch({
        type: "GET_TAX_TYPE_APPLICATIONS_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-applications`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_TAX_TYPE_APPLICATIONS_SELECT_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "SHOW_MESSAGE",
              payload: {
                type: "error",
                titleKey: "error",
                message: error.message
              }
            })
          )
      });
    }
  };
}

export function getTaxTypeApplication(taxTypeApplicationId, forceRefresh = false) {
  return (dispatch, getState) => {
    if (!getState().taxTypeApplicationsReducer.updating || forceRefresh) {
      if (taxTypeApplicationId === 0) {
        return dispatch({
          type: "GET_TAX_TYPE_APPLICATION_FULFILLED",
          payload: {
            id: 0,
            internalName: "",
            nameFrench: "",
            nameEnglish: "",
            createdDate: new Date()
          }
        });
      }
      return dispatch({
        type: "GET_TAX_TYPE_APPLICATION_PENDING",
        payload: axios
          .get(`${HOST}/api/tax-type-applications/${taxTypeApplicationId}`)
          .then(response => response.data)
          .then(json =>
            dispatch({
              type: "GET_TAX_TYPE_APPLICATION_FULFILLED",
              payload: json
            })
          )
          .catch(error =>
            dispatch({
              type: "GET_TAX_TYPE_APPLICATION_REJECTED",
              payload: error
            })
          )
      });
    }
  };
}

export function updateTaxTypeApplication(taxTypeApplication) {
  return dispatch =>
    dispatch({
      type: "UPDATE_TAX_TYPE_APPLICATION",
      payload: taxTypeApplication
    });
}

export function persistTaxTypeApplication(taxTypeApplication) {
  return (dispatch, getState) => {
    if (!getState().taxTypeApplicationsReducer.updating) {
      return new Promise((resolve, reject) =>
        dispatch({
          type: "PERSISTING_TAX_TYPE_APPLICATION",
          payload: (taxTypeApplication.id === 0
            ? axios.post(`${HOST}/api/tax-type-applications`, taxTypeApplication)
            : axios.put(`${HOST}/api/tax-type-applications/${taxTypeApplication.id}`, taxTypeApplication)
          )
            .then(response => response.data)
            .then(json => {
              dispatch({
                type: "PERSISTED_TAX_TYPE_APPLICATION",
                payload: {
                  taxTypeApplication: json,
                  isNew: taxTypeApplication.id === 0
                }
              });

              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "success",
                  titleKey: "success",
                  messageKey: "saved_successful"
                }
              });
              return resolve();
            })
            .catch(error => {
              dispatch({
                type: "SHOW_MESSAGE",
                payload: {
                  type: "error",
                  titleKey: "error",
                  message: error.response
                }
              });
              return reject();
            })
        })
      );
    }
  };
}
